/**
 * ./warmup/warmupwelcome.js
 * 
 * 
 */

import React from "react";
import "../warmup/Warmupwelcome.css"; // Import the CSS file
import { useNavigate, useLocation } from 'react-router-dom';
import IconBubble from "../components/IconBubble/IconBubble";
import Star2 from "../components/icons/star2.svg";

const WarmupIntro = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const exerciseNumber = location.state?.exerciseNumber || 2;
  const handleStartClick = () => {
    console.log(exerciseNumber)
    navigate("/warmup1", { state: { exerciseNumber: exerciseNumber} }); // Update with the correct route, Carry over ExerciseNum
  };

  return (
    <div className="exercise1-intro-container">
      <div className="sunny-intro">
        <img src={Star2} alt="sunny" className="sunny" />
        <IconBubble
          width={620}
          height={100}
          HTML={`<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
          Let's start with the warmup!
        </span>`}
          color="FFFFFF"
          fontSize={25}
        />
      </div>
      <div className="bottom-buttons">
        <button className="guidance-and-start-button" onClick={handleStartClick}>
          Start
        </button>
      </div>
    </div>
  );
};

export default WarmupIntro;
